export const PlusIcon = ({
  fillColor = '#18181B',
  width = 20,
  height = 20
}: {
  fillColor?: string;
  width?: number;
  height?: number;
}) => {
  return (
    <svg width={width} height={height} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M17.8145 10.0015C17.8145 10.2501 17.7157 10.4886 17.5399 10.6644C17.364 10.8402 17.1256 10.939 16.877 10.939H10.9395V16.8765C10.9395 17.1251 10.8407 17.3636 10.6649 17.5394C10.489 17.7152 10.2506 17.814 10.002 17.814C9.75331 17.814 9.51486 17.7152 9.33904 17.5394C9.16323 17.3636 9.06445 17.1251 9.06445 16.8765V10.939H3.12695C2.87831 10.939 2.63986 10.8402 2.46404 10.6644C2.28823 10.4886 2.18945 10.2501 2.18945 10.0015C2.18945 9.75282 2.28823 9.51437 2.46404 9.33855C2.63986 9.16274 2.87831 9.06396 3.12695 9.06396H9.06445V3.12646C9.06445 2.87782 9.16323 2.63937 9.33904 2.46355C9.51486 2.28774 9.75331 2.18896 10.002 2.18896C10.2506 2.18896 10.489 2.28774 10.6649 2.46355C10.8407 2.63937 10.9395 2.87782 10.9395 3.12646V9.06396H16.877C17.1256 9.06396 17.364 9.16274 17.5399 9.33855C17.7157 9.51437 17.8145 9.75282 17.8145 10.0015Z"
        fill={fillColor}
      />
    </svg>
  );
};

PlusIcon.displayName = 'MakroUI.PlusIcon';
